import { reduxStore } from 'services/configureStore';
import { setUserRole } from 'reducers/userAuthSlice';
/**
 * check if current User is the Account owner of current Account
 */
export const isOwnerOfAccount = user => {
	const currentAccountId = reduxStore.getState().userAuth.currentAccountId;
	const account = user?.accounts?.find(account => account.id === currentAccountId);
	// const account = JSON.parse(getLocalStorage('currentAccount'));
	if (!account || !user) return false;
	return account.owner_id === user.id;
};

/**
 * @description check if user is updating current user Role
 * @description update userRole redux store if updating current user Role
 * @param {dispatch} fn
 * @param {userRole} object
 * @param {data} object
 */
export const updateUserRole = ({ dispatch, userRole, updatedRoleResp }) => {
	// update current user Role if user is assigned to updated Role.
	if (updatedRoleResp.id !== userRole.id) return;
	dispatch(setUserRole(updatedRoleResp));
	return;
};

/**
 * return Boolean if user has access to selected target
 * @param {target} target
 */
export const hasPermission = ({ userRole, targetVal, ownerID, owners }) => {
	const user = reduxStore.getState().userAuth.user;
	if (isOwnerOfAccount(user)) return true;

	if (!userRole) return false;
	const targetValue = userRole.permissions[targetVal];
	// handle Toggle Input
	if ([true, false].includes(targetValue)) return targetValue;

	// handle dropdown Options
	// if user has all access or true
	if (targetValue === 'all') return true;

	// if user has none access or false
	if (targetValue === 'none') return false;

	// if user has "own" access

	const idProvided = ownerID || owners;
	if (!idProvided) return false;

	if (ownerID) {
		return targetValue === 'own' && ownerID === user.id ? true : false;
	}
	if (Array.isArray(owners)) {
		const ownerIds = owners.map(owner => owner.id);
		const ownerUserIds = owners.map(owner => owner.user_id);
		return targetValue === 'own' && (ownerIds.includes(user.id) || ownerUserIds.includes(user.id));
	}
};
